"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormTextarea = exports.FormSelect = exports.FormRadio = exports.FormInput = exports.FormFieldset = exports.FormDataList = exports.FormCheckbox = exports.FormButton = void 0;
require("core-js/modules/es.json.stringify.js");
require("core-js/modules/es.symbol.description.js");
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var FV = _interopRequireWildcard(require("./pixelated.formvalidations"));
require("./pixelated.form.css");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /* eslint-disable */
const _onChange = (me, event) => {
  let myValidate = me.props.validate ? FV[me.props.validate](event.target) : true;
  let myParentValidate = me.props.parent && me.props.parent.validate ? FV[me.props.parent.validate](event.target) : true;
  let myRequired = me.props.required ? event.target.checkValidity() : true;
  let myRequiredNotEmpty = me.props.required && !event.target.value ? false : true;
  let myValid = myValidate && myParentValidate && myRequired && myRequiredNotEmpty ? true : false;
  me.setState({
    isValid: myValid
  });
  if (me.props.setIsValid) me.props.setIsValid(myValid);
  // if (me.props.parent && me.props.parent.setIsValid) me.props.parent.setIsValid(myValid);
  return true;
};
class FormLabel extends _react.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, this.props.label && this.props.id ? /*#__PURE__*/_react.default.createElement("label", {
      id: this.props.id,
      htmlFor: this.props.id
    }, this.props.label) : "", this.props.tooltip ? /*#__PURE__*/_react.default.createElement(FormTooltip, {
      id: this.props.id,
      text: this.props.tooltip
    }) : "");
  }
}
_defineProperty(FormLabel, "propTypes", {
  id: _propTypes.default.string,
  label: _propTypes.default.string,
  tooltip: _propTypes.default.string
});
_defineProperty(FormLabel, "defaultProps", {
  id: "",
  label: "",
  tooltip: ""
});
class FormTooltip extends _react.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "toggleTooltip", e => {
      e.preventDefault();
      if (e.target.nextSibling.style.display == "block") {
        e.target.nextSibling.style.display = "none";
      } else {
        e.target.nextSibling.style.display = "block";
      }
      return false;
    });
    this.toggleTooltip = this.toggleTooltip.bind(this);
  }
  // ℹ	8505	2139	 	INFORMATION SOURCE
  // ⚠	9888	26A0	 	WARNING SIGN
  // 				24BE		I IN CIRCLE
  render() {
    let thisID = "tooltip-" + this.props.id;
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, this.props.text && this.props.id ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
      id: thisID,
      className: "tooltip"
    }, /*#__PURE__*/_react.default.createElement("a", {
      href: "#",
      className: "tooltip-icon",
      onClick: this.toggleTooltip
    }, '\u2139'), /*#__PURE__*/_react.default.createElement("div", {
      className: "tooltip-text"
    }, this.props.text))) : "");
  }
}
_defineProperty(FormTooltip, "propTypes", {
  id: _propTypes.default.string,
  text: _propTypes.default.string
});
_defineProperty(FormTooltip, "defaultProps", {
  id: "",
  text: ""
});
class FormValidate extends _react.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, !this.props.valid ? /*#__PURE__*/_react.default.createElement("span", {
      id: this.props.id
    }, this.props.valid ? "\u2705" : "\u274C") : "");
  }
}
_defineProperty(FormValidate, "propTypes", {
  id: _propTypes.default.string,
  valid: _propTypes.default.bool
});
class FormInput extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      isValid: true
    };
  }
  render() {
    let formValidate = /*#__PURE__*/_react.default.createElement(FormValidate, {
      id: "".concat(this.props.id, "-validate"),
      valid: this.state.isValid
    });
    // ----- Input Props
    let inputProps = JSON.parse(JSON.stringify(this.props));
    ["display", "label", "validate"].forEach(e => delete inputProps[e]);
    inputProps["onChange"] = e => _onChange(this, e);
    inputProps["className"] = this.props.display == "vertical" ? "displayVertical" : "";
    ["submit", "button"].indexOf(this.props.type) > -1 ? inputProps["value"] = this.props.value : "";
    return /*#__PURE__*/_react.default.createElement("div", null, this.props.type == "checkbox" ? /*#__PURE__*/_react.default.createElement("input", inputProps) : "", /*#__PURE__*/_react.default.createElement(FormLabel, {
      key: "label-" + this.props.id,
      id: this.props.id,
      label: this.props.label
    }), this.props.tooltip ? /*#__PURE__*/_react.default.createElement(FormTooltip, {
      id: this.props.id,
      text: this.props.tooltip
    }) : "", this.props.display == "vertical" ? formValidate : "", this.props.type != "checkbox" ? /*#__PURE__*/_react.default.createElement("input", inputProps) : "", this.props.list ? /*#__PURE__*/_react.default.createElement(FormDataList, {
      id: this.props.list,
      items: FV[this.props.list]
    }) : "", this.props.display != "vertical" ? formValidate : "");
  }
}
exports.FormInput = FormInput;
_defineProperty(FormInput, "propTypes", {
  type: _propTypes.default.string,
  id: _propTypes.default.string,
  name: _propTypes.default.string,
  defaultValue: _propTypes.default.string,
  list: _propTypes.default.string,
  size: _propTypes.default.string,
  maxLength: _propTypes.default.string,
  placeholder: _propTypes.default.string,
  autoComplete: _propTypes.default.string,
  "aria-label": _propTypes.default.string,
  min: _propTypes.default.string,
  max: _propTypes.default.string,
  step: _propTypes.default.string,
  // flag attributes
  autoFocus: _propTypes.default.string,
  disabled: _propTypes.default.string,
  readOnly: _propTypes.default.string,
  required: _propTypes.default.string,
  // className, 
  // data-mapping, data-component-endpoint, data-testid
  // aria-invalid, aria-describedby, 
  // ----- for calculations
  display: _propTypes.default.string,
  label: _propTypes.default.string,
  tooltip: _propTypes.default.string,
  validate: _propTypes.default.string
});
class FormSelect extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      isValid: true
    };
  }
  generateOptions() {
    let options = [];
    for (var option in this.props.options) {
      let thisOption = this.props.options[option];
      let thisKey = "select-" + this.props.id + "-" + thisOption.value;
      let newOption = /*#__PURE__*/_react.default.createElement(FormSelectOption, _extends({
        key: thisKey
      }, thisOption));
      options.push(newOption);
    }
    return options;
  }
  render() {
    let formValidate = /*#__PURE__*/_react.default.createElement(FormValidate, {
      id: "".concat(this.props.id, "-validate"),
      valid: this.state.isValid
    });
    // ----- Input Props
    let inputProps = JSON.parse(JSON.stringify(this.props));
    ["options", "display", "label", "validate"].forEach(e => delete inputProps[e]);
    inputProps["onChange"] = e => _onChange(this, e);
    inputProps["className"] = this.props.display == "vertical" ? "displayVertical" : "";
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(FormLabel, {
      key: "label-" + this.props.id,
      id: this.props.id,
      label: this.props.label
    }), this.props.tooltip ? /*#__PURE__*/_react.default.createElement(FormTooltip, {
      id: this.props.id,
      text: this.props.tooltip
    }) : "", this.props.display == "vertical" ? formValidate : "", /*#__PURE__*/_react.default.createElement("select", inputProps, this.generateOptions()), this.props.display != "vertical" ? formValidate : "");
  }
}
exports.FormSelect = FormSelect;
_defineProperty(FormSelect, "propTypes", {
  id: _propTypes.default.string,
  name: _propTypes.default.string,
  size: _propTypes.default.string,
  autoComplete: _propTypes.default.string,
  defaultValue: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
  // flag attributes
  autoFocus: _propTypes.default.string,
  disabled: _propTypes.default.string,
  multiple: _propTypes.default.string,
  readOnly: _propTypes.default.string,
  required: _propTypes.default.string,
  // selected: PropTypes.string, // not used
  // ----- for calculations
  options: _propTypes.default.array,
  display: _propTypes.default.string,
  label: _propTypes.default.string,
  tooltip: _propTypes.default.string,
  validate: _propTypes.default.string
});
class FormSelectOption extends _react.Component {
  constructor(props) {
    super(props);
  }
  render() {
    let inputProps = JSON.parse(JSON.stringify(this.props));
    ["selected"].forEach(e => delete inputProps[e]);
    return /*#__PURE__*/_react.default.createElement("option", inputProps, this.props.text);
  }
}
_defineProperty(FormSelectOption, "propTypes", {
  text: _propTypes.default.string,
  value: _propTypes.default.string,
  // flag attributes
  disabled: _propTypes.default.string
  // selected : PropTypes.string
});

class FormTextarea extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      isValid: true
    };
  }
  render() {
    let formValidate = /*#__PURE__*/_react.default.createElement(FormValidate, {
      id: "".concat(this.props.id, "-validate"),
      valid: this.state.isValid
    });
    // ----- Input Props
    let inputProps = JSON.parse(JSON.stringify(this.props));
    ["display", "label", "validate"].forEach(e => delete inputProps[e]);
    inputProps["onChange"] = e => _onChange(this, e);
    inputProps["className"] = this.props.display == "vertical" ? "displayVertical" : "";
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(FormLabel, {
      key: "label-" + this.props.id,
      id: this.props.id,
      label: this.props.label
    }), this.props.tooltip ? /*#__PURE__*/_react.default.createElement(FormTooltip, {
      id: this.props.id,
      text: this.props.tooltip
    }) : "", this.props.display == "vertical" ? formValidate : "", /*#__PURE__*/_react.default.createElement("textarea", inputProps), this.props.display != "vertical" ? formValidate : "");
  }
}
exports.FormTextarea = FormTextarea;
_defineProperty(FormTextarea, "propTypes", {
  id: _propTypes.default.string,
  name: _propTypes.default.string,
  rows: _propTypes.default.string,
  cols: _propTypes.default.string,
  defaultValue: _propTypes.default.string,
  maxLength: _propTypes.default.number,
  placeholder: _propTypes.default.string,
  autoComplete: _propTypes.default.string,
  // flag attributes
  autoFocus: _propTypes.default.string,
  disabled: _propTypes.default.string,
  readOnly: _propTypes.default.string,
  required: _propTypes.default.string,
  // ----- for calculations
  display: _propTypes.default.string,
  label: _propTypes.default.string,
  tooltip: _propTypes.default.string,
  validate: _propTypes.default.string
});
class FormRadio extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      isValid: true
    };
    this.setIsValid = this.setIsValid.bind(this);
  }
  setIsValid(validValue) {
    this.setState({
      isValid: validValue
    });
  }
  generateOptions() {
    let options = [];
    for (var option in this.props.options) {
      let thisOption = this.props.options[option];
      thisOption.parent = this.props;
      thisOption.setIsValid = this.setIsValid;
      let thisKey = "radio-" + this.props.id + "-" + thisOption.value;
      let newOption = /*#__PURE__*/_react.default.createElement(FormRadioOption, _extends({
        key: thisKey
      }, thisOption));
      options.push(newOption);
    }
    return options;
  }
  render() {
    let formValidate = /*#__PURE__*/_react.default.createElement(FormValidate, {
      id: "".concat(this.props.id, "-validate"),
      valid: this.state.isValid
    });
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(FormLabel, {
      key: "label-" + this.props.id,
      id: this.props.name,
      label: this.props.label
    }), this.props.tooltip ? /*#__PURE__*/_react.default.createElement(FormTooltip, {
      id: this.props.id,
      text: this.props.tooltip
    }) : "", this.props.display == "vertical" ? formValidate : "", this.generateOptions(), this.props.display != "vertical" ? formValidate : "");
  }
}
exports.FormRadio = FormRadio;
_defineProperty(FormRadio, "propTypes", {
  id: _propTypes.default.string,
  // not using?
  name: _propTypes.default.string,
  options: _propTypes.default.array,
  // flag attributes
  autoFocus: _propTypes.default.string,
  disabled: _propTypes.default.string,
  readOnly: _propTypes.default.string,
  required: _propTypes.default.string,
  // ? selected: PropTypes.string,
  // ----- for calculations
  display: _propTypes.default.string,
  label: _propTypes.default.string,
  tooltip: _propTypes.default.string,
  validate: _propTypes.default.string
});
class FormRadioOption extends _react.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: this.props.parent.display == "vertical" ? "displayVertical" : ""
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "radio",
      id: "".concat(this.props.name, "-").concat(this.props.value),
      name: this.props.parent.name,
      value: this.props.value,
      defaultChecked: this.props.checked ? "checked" : "",
      required: this.props.parent.required ? "required" : "",
      onChange: e => _onChange(this, e)
    }), /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: this.props.text
    }, this.props.text));
  }
}
_defineProperty(FormRadioOption, "propTypes", {
  text: _propTypes.default.string,
  value: _propTypes.default.string,
  // flag attributes
  checked: _propTypes.default.string,
  // ----- for calculations
  parent: _propTypes.default.object,
  setIsValid: _propTypes.default.func
});
class FormCheckbox extends _react.Component {
  constructor(props) {
    super(props);
    this.state = {
      isValid: true
    };
    this.setIsValid = this.setIsValid.bind(this);
  }
  setIsValid(validValue) {
    this.setState({
      isValid: validValue
    });
  }
  generateOptions() {
    let options = [];
    for (var option in this.props.options) {
      let thisOption = this.props.options[option];
      thisOption.parent = this.props;
      thisOption.setIsValid = this.setIsValid;
      let thisKey = "checkbox-" + this.props.name + "-" + thisOption.value;
      let newOption = /*#__PURE__*/_react.default.createElement(FormCheckboxOption, _extends({
        key: thisKey
      }, thisOption));
      options.push(newOption);
    }
    return options;
  }
  render() {
    let formValidate = /*#__PURE__*/_react.default.createElement(FormValidate, {
      id: "".concat(this.props.id, "-validate"),
      valid: this.state.isValid
    });
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(FormLabel, {
      key: "label-" + this.props.id,
      id: this.props.name,
      label: this.props.label
    }), this.props.tooltip ? /*#__PURE__*/_react.default.createElement(FormTooltip, {
      id: this.props.id,
      text: this.props.tooltip
    }) : "", this.props.display == "vertical" ? formValidate : "", this.generateOptions(), this.props.display != "vertical" ? formValidate : "");
  }
}
exports.FormCheckbox = FormCheckbox;
_defineProperty(FormCheckbox, "propTypes", {
  name: _propTypes.default.string,
  options: _propTypes.default.array,
  // flag attributes
  autoFocus: _propTypes.default.string,
  disabled: _propTypes.default.string,
  readOnly: _propTypes.default.string,
  // ----- for calculations
  display: _propTypes.default.string,
  label: _propTypes.default.string,
  tooltip: _propTypes.default.string,
  validate: _propTypes.default.string
});
class FormCheckboxOption extends _react.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: this.props.parent.display == "vertical" ? "displayVertical" : ""
    }, /*#__PURE__*/_react.default.createElement("input", {
      type: "checkbox",
      id: this.props.parent.name + "_" + this.props.text,
      name: this.props.text,
      value: this.props.value,
      onChange: e => _onChange(this, e)
    }), /*#__PURE__*/_react.default.createElement("label", {
      htmlFor: this.props.text
    }, this.props.text));
  }
}
_defineProperty(FormCheckboxOption, "propTypes", {
  text: _propTypes.default.string,
  value: _propTypes.default.string,
  // flag attributes
  selected: _propTypes.default.string,
  // ----- for calculations
  parent: _propTypes.default.object,
  setIsValid: _propTypes.default.func
});
class FormButton extends _react.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("button", {
      type: this.props.type,
      id: this.props.id,
      onClick: this.props.onClick
    }, this.props.text));
  }
}
exports.FormButton = FormButton;
_defineProperty(FormButton, "propTypes", {
  type: _propTypes.default.string,
  id: _propTypes.default.string,
  text: _propTypes.default.string,
  // ----- for calculations
  onClick: _propTypes.default.func
});
class FormDataList extends _react.Component {
  constructor(props) {
    super(props);
  }
  render() {
    const options = [];
    for (const item in this.props.items) {
      const thisItem = this.props.items[item];
      const newOption = /*#__PURE__*/_react.default.createElement("option", {
        key: this.props.id + '-' + thisItem,
        value: thisItem
      });
      options.push(newOption);
    }
    return /*#__PURE__*/_react.default.createElement("datalist", {
      id: this.props.id
    }, options);
  }
}
exports.FormDataList = FormDataList;
_defineProperty(FormDataList, "propTypes", {
  id: _propTypes.default.string,
  items: _propTypes.default.array
});
class FormFieldset extends _react.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return /*#__PURE__*/_react.default.createElement(_react.Fragment, null);
  }
}
exports.FormFieldset = FormFieldset;
_defineProperty(FormFieldset, "propTypes", {});